import type { FunctionComponent, HTMLAttributes } from "preact";
import { useMemo } from "preact/hooks";
import { useLocation } from "wouter-preact";
import { useMergedClassName } from "../utils.ts";
import { Icon } from "../icon/icon.tsx";
import { setDrawerNavOpen } from "../../store/browser_var.ts";
import { useStore } from "@nanostores/preact";
import { $organizationName } from "../../store/user_info.ts";

export type HeaderNavProps = HTMLAttributes<HTMLDivElement> & {
    title?: string;
    showMenu?: boolean;
};

export const HeaderNav: FunctionComponent<HeaderNavProps> = (props: HeaderNavProps) => {
    const [_, setLocation] = useLocation();
    const organizationName = useStore($organizationName);
    // Merge classes: keep both container classes to maintain styling hooks while flattening DOM
    const className = useMergedClassName("farpov_header_nav_container container", props.class);
    const goHome = useMemo((() => () => setLocation("/")), [setLocation]);
    const openDrawerNav = useMemo((() => () => setDrawerNavOpen(true)), [setDrawerNavOpen]);
    const showMenu = props.showMenu ?? true;
    
    return (
        <div class={className} {...props}>
            {showMenu ? (
                <button 
                    type="button"
                    class="farpov_header_nav_icon_wrap farpov_header_nav_menu_button" 
                    onClick={openDrawerNav}
                    aria-label="Menu"
                    style={{ background: "transparent", border: "none", margin: 0 }}
                >
                    <Icon name="menu" />
                </button>
            ) : (
                <div class="farpov_header_nav_icon_wrap farpov_header_nav_menu_button" style="visibility: hidden; pointer-events: none;">
                    <Icon name="menu" />
                </div>
            )}
            <span class="farpov_header_nav_title">{props.title ? props.title : organizationName}</span>
            <button 
                type="button"
                class="farpov_header_nav_icon_wrap farpov_header_nav_home_button" 
                onClick={goHome}
                aria-label="Home"
                style={{ background: "transparent", border: "none", margin: 0 }}
            >
                <Icon name="home" />
            </button>
        </div>
    );
};
export default HeaderNav;
